import { useSearch } from "@tanstack/react-router";
import { useContext, useEffect } from "react";

import { ConnectAccountParams } from "../ConnectAccount/ConnectAccount";
import ThemeContext from "../context";
import { useMutateStartFlow } from "./useMutateStartFlow";

type Props = {
	subproduct?: string;
};

export const useStartFlow = ({ subproduct }: Props) => {
	const { id, state } = useContext(ThemeContext);

	const { externalId, updateToken, restoreToken }: ConnectAccountParams = useSearch({
		strict: false
	});

	const isUpdateFlow = updateToken || restoreToken;

	const { startFlow, startUpdateFlow, isLoading } = useMutateStartFlow();

	useEffect(() => {
		if (id && !state.authToken) isUpdateFlow ? startUpdateFlow() : startFlow(externalId);
	}, [subproduct]);

	return { isLoading };
};
